import { type Context, createContext } from 'react';

/** @internal */
export type AccordionSectionContextProps = {
  labelId: string;
  contentId: string;
  isExpanded: boolean;
  keepMounted: boolean;
  size: 'default' | 'condensed';
};

/** @internal */
export const AccordionSectionContext: Context<AccordionSectionContextProps> =
  createContext<AccordionSectionContextProps>({
    labelId: '',
    contentId: '',
    isExpanded: false,
    keepMounted: false,
    size: 'default',
  });
